import { useNavigate } from 'react-router-dom';
import {
  IntegrationsSection as SharedIntegrationsSection,
  SettingsBundleProvider,
} from '@triedge/staff-settings-ui';
import { useShellProfile } from '../../../state/useShellProfile';
import { settingsFeatureBundle } from '../../../settings/featureBundle';
import { Button, Card } from '../components/ui';
import {
  SUPER_ADMIN_CONTROL_PLANE_ASSISTANT_BRIDGE,
  SUPER_ADMIN_CONTROL_PLANE_PAYMENTS,
} from '../../super-admin-control-plane/paths';

export default function Integrations() {
  const navigate = useNavigate();
  const { effectivePersona } = useShellProfile();
  const isSuperAdmin = effectivePersona === 'super-administrator';

  return (
    <SettingsBundleProvider value={settingsFeatureBundle}>
      <section
        className="space-y-6"
        data-testid="control-plane-integrations-root"
        data-testid-alias="settings-integrations-root"
      >
        {isSuperAdmin ? (
          <Card data-testid="control-plane-integrations-links-card">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#237062]">
                  Integrations
                </p>
                <p className="mt-2 text-sm text-[#374151]">
                  This control-plane surface owns spreadsheet bridge status,
                  export controls, and operator jump-points into the deeper
                  payments and assistant bridge lanes.
                </p>
              </div>
              <div className="flex flex-wrap gap-2">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => navigate(SUPER_ADMIN_CONTROL_PLANE_PAYMENTS)}
                  data-testid="control-plane-integrations-open-payments-button"
                >
                  Payments
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() =>
                    navigate(SUPER_ADMIN_CONTROL_PLANE_ASSISTANT_BRIDGE)
                  }
                  data-testid="control-plane-integrations-open-assistant-bridge-button"
                >
                  Assistant Bridge
                </Button>
              </div>
            </div>
          </Card>
        ) : null}
        <SharedIntegrationsSection />
      </section>
    </SettingsBundleProvider>
  );
}
